import { dynamicEnvironment, EnvironmentConfig } from './environment-common'

export const environment: EnvironmentConfig = {
  ...dynamicEnvironment,
  production: true,
  environmentName: 'PROD',
  apiUrl: 'https://settlement-api.ce.ameren.com',
}
